import { render, staticRenderFns } from "./boardOneItem.vue?vue&type=template&id=204251e0&scoped=true"
import script from "./boardOneItem.vue?vue&type=script&lang=js"
export * from "./boardOneItem.vue?vue&type=script&lang=js"
import style0 from "./boardOneItem.vue?vue&type=style&index=0&id=204251e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204251e0",
  null
  
)

export default component.exports